import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';
import ReactSound from 'react-sound';
import playScore from '../sounds/play-score.ogg';
import { useSelector } from 'react-redux';
import { EggNumber } from './EggNumber';

const DisplayScore = ({ stageNumber, soulAmount, eggAmount }) => {
  const { images } = useImagesContext();
  return (
    <>
      <FullScreenImage
        src={images[`play-score-${stageNumber}.png`]}
      />
      <FadeInBlock
        style={{
          position: 'relative',
          top: '370px',
          marginLeft: '50px',
        }}
      >
        <EggNumber
          number={eggAmount}
          // top="300px"
          fontHeight="72px"
          filePrefix="play-egg-player-"
        />
      </FadeInBlock>
      <FadeInBlock
        style={{
          position: 'relative',
          top: '600px',
          marginLeft: '50px',
        }}
      >
        <EggNumber
          number={soulAmount}
          // top="300px"
          fontHeight="72px"
          filePrefix="play-egg-boss-"
        />
      </FadeInBlock>
    </>
  );
};

const Score = ({ stageNumber, soulAmount, eggAmount }) => {
  const config = useSelector((state) => state.config);
  return (
    <>
      <DisplayScore
        stageNumber={stageNumber}
        soulAmount={soulAmount}
        eggAmount={eggAmount}
      />
      <ReactSound
        url={playScore}
        playStatus="PLAYING"
        volume={config.isMutedSound ? 0 : 100}
        loop={false}
      ></ReactSound>
    </>
  );
};

const FullScreenImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const FadeInBlock = styled.div`
  animation: ${fadeIn} 3s ease-in-out;
`;

export default Score;
